import { valueOf } from "@/types/common";

export const PAYROLL_STATUS = {
  OK: 1,
  ERROR: 2,
  ADDED: 3,
};

export type TPayrollStatus = valueOf<typeof PAYROLL_STATUS>;
